import React from 'react';

const AnchorButton = ({ className = '', href, label, onClick, onKeyDown }) => {
    return (
        <a className={`clx-step__anchor-button ${className}`} href={href} onClick={onClick} onKeyDown={onKeyDown}>
            {label}
        </a>
    );
};

export default AnchorButton;
